import { createStaticPropsGetter,Page } from "@/libs/pages";

export const getStaticProps = createStaticPropsGetter("comment-ca-marche");

export default Page;
